/* Small progressive enhancements; no scroll hijacking or animation dependency. */
(() => {
  if (window.ZivaBuyDesign) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting}) => {
      target.classList.toggle('zb-scene-visible', isIntersecting);
      if (!isIntersecting) return;
      if (!motion.matches) target.classList.add('zb-in-view');

    });
  }, {threshold: .06});
  function enhance(scope = document) {
    const sections = [...scope.querySelectorAll('.zb-section')];
    if (scope.matches?.('.zb-section')) sections.unshift(scope);
    sections.forEach((node) => observer.observe(node));
    scope.querySelectorAll('.zb-product-stage').forEach((node) => node.setAttribute('data-zb-depth', ''));
  }
  let frame = 0;
  document.addEventListener('pointermove', (event) => {
    if (motion.matches || !pointer.matches) return;
    const stage = event.target.closest('[data-zb-depth]');
    if (!stage) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const r = stage.getBoundingClientRect();
      stage.style.setProperty('--zb-tilt-x', `${((event.clientY-r.top)/r.height-.5)*-5}deg`);
      stage.style.setProperty('--zb-tilt-y', `${((event.clientX-r.left)/r.width-.5)*7}deg`);
    });
  }, {passive:true});
  document.addEventListener('pointerout', (event) => {
    const stage = event.target.closest('[data-zb-depth]');
    if (stage && !stage.contains(event.relatedTarget)) {
      cancelAnimationFrame(frame);
      stage.style.setProperty('--zb-tilt-x','0deg'); stage.style.setProperty('--zb-tilt-y','0deg');
    }
  });
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.zb-section').forEach((node) => observer.unobserve(node));
  });
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll('[data-zb-depth]').forEach((node) => {
      node.style.setProperty('--zb-tilt-x','0deg'); node.style.setProperty('--zb-tilt-y','0deg');
    });
  });
  const progress = document.createElement('div');
  progress.className = 'zb-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  if (document.body.classList.contains('zb-home')) document.body.append(progress);
  let scrollFrame = 0;
  function updateScroll() {
    scrollFrame = 0;
    document.body.classList.toggle('zb-header-scrolled', scrollY > 48);
    const range = document.documentElement.scrollHeight - innerHeight;
    progress.style.setProperty('--zb-reading-progress', `${range > 0 ? Math.min(100, scrollY / range * 100) : 0}%`);
    const hero = document.querySelector('.zb-hero');
    if (hero && !motion.matches) {
      const bounds = hero.getBoundingClientRect();
      if (bounds.bottom > 0 && bounds.top < innerHeight) hero.style.setProperty('--zb-parallax', `${Math.min(18, Math.max(-18, -bounds.top * .025))}px`);
    }
  }
  function scheduleScroll() {
    if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll);
  }
  addEventListener('scroll', scheduleScroll, {passive: true});
  addEventListener('resize', scheduleScroll, {passive: true});
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('zb-design-paused', document.hidden));
  motion.addEventListener('change', () => {
    document.querySelector('.zb-hero')?.style.removeProperty('--zb-parallax');
    scheduleScroll();
  });
  enhance(); updateScroll(); window.ZivaBuyDesign = {enhance};
})();

/* Shopify editor-safe video lifecycle. No automatic playback under reduced motion. */
if (!customElements.get('zb-video-hero')) customElements.define('zb-video-hero', class extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('.zb-hero__video-toggle');
    if (!this.video || !this.toggle) return;
    this.abort = new AbortController();
    const options = {signal: this.abort.signal};
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.connection = navigator.connection;
    if (this.video.dataset.zbMobileSrc) this.video.src = matchMedia('(max-width: 767px)').matches ? this.video.dataset.zbMobileSrc : this.video.dataset.zbDesktopSrc;
    this.userPaused = false;
    this.visible = false;
    this.video.muted = true;
    this.video.tabIndex = -1;
    this.toggle.hidden = false;
    this.toggle.addEventListener('click', () => {
      if (this.video.paused) { this.userPaused = false; this.start(true); }
      else { this.userPaused = true; this.video.pause(); }
    }, options);
    const sync = () => {
      const playing = !this.video.paused;
      this.classList.toggle('zb-hero--video-playing', playing);
      if (playing) this.classList.add('zb-hero--video-started');
      const label = playing ? 'Pause background video' : 'Play background video';
      this.toggle.setAttribute('aria-label', label);
      this.toggle.querySelector('[data-zb-video-label]').textContent = label;
    };
    this.video.addEventListener('playing', sync, options);
    this.video.addEventListener('pause', sync, options);
    this.video.addEventListener('error', () => {
      this.video.pause();
      this.classList.remove('zb-hero--video-started');
      this.toggle.hidden = true;
    }, options);
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.reconcile();
    }, {threshold: .05});
    this.observer.observe(this);
    document.addEventListener('visibilitychange', () => this.reconcile(), options);
    this.motion.addEventListener('change', () => this.reconcile(), options);
    this.connection?.addEventListener('change', () => this.reconcile(), options);
    sync();
  }
  reconcile() {
    if (document.hidden || !this.visible || this.motion.matches || this.connection?.saveData || this.userPaused) this.video.pause();
    else this.start();
  }
  async start(explicit = false) {
    try { await this.video.play(); }
    catch (_) { /* Autoplay restrictions keep the fallback and explicit Play control. */ }
    if (!this.isConnected || document.hidden || !this.visible || this.userPaused || (!explicit && (this.motion.matches || this.connection?.saveData))) this.video.pause();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.video?.pause();
  }
});
